export const fieldsProducts = [
  {
    key: 'checkbox',
    label: '',
    thClass: 'text-black text-capitalize py-1 font-semibold',
    class: 'bg-white align-top',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: 'text-black text-capitalize py-1',
    class: 'bg-white align-top',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'product_variants',
    label: 'Variasi',
    thClass: 'text-black text-capitalize py-1 text-center',
    class: 'bg-white align-center',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'volume',
    label: 'Dimensi',
    thClass: 'text-black text-capitalize py-1 text-center',
    class: 'bg-white align-top',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'storage_type',
    label: 'Jenis Penyimpanan',
    thClass: 'text-black text-capitalize py-1 text-center',
    class: 'bg-white align-top',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
    },
    tdClass: 'text-black align-middle',
  },
  {
    key: 'bahan_packing',
    label: 'Bahan Packing',
    thClass: 'text-black text-capitalize py-1 text-center',
    class: 'bg-white align-top',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '260px',
    },
    tdClass: 'text-black',
  },
  {
    key: 'product_bonus',
    label: 'Aktifkan Produk Bonus',
    thClass: 'text-black text-capitalize py-1 text-center',
    class: 'bg-white align-top',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      width: '160px',
    },
    tdClass: 'text-black',
  },
]

export const fieldsBundling = [
  {
    key: 'no',
    label: 'No',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize bg-white',
    tdClass: 'text-black',
  },
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize bg-white',
    tdClass: 'text-black',
  },
  {
    key: 'qty',
    label: 'Jumlah',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize text-center bg-white',
    tdClass: 'text-black text-center',
  },
]

export const storageTypeOptions = ({ is_cold_storage }) => [
  {
    value: 1,
    text: 'Dry Storage',
  },
  {
    value: 2,
    text: 'Cold Storage',
    disabled: !is_cold_storage,
  },
]

export const fieldsVariantBundling = [
  {
    key: 'no',
    label: 'No',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize bg-white w-[30px]',
    tdClass: 'text-black',
  },
  {
    key: 'variant_name',
    label: 'Nama Varian',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize bg-white min-w-[200px]',
    tdClass: 'text-black',
  },
  {
    key: 'bundle_component',
    label: 'Relasi Produk',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize bg-white min-w-[250px]',
    tdClass: 'text-black',
  },
]
